import { useState } from "react";
import Index from "./pages/index";
import Home from "./pages/home";
import Lift from "./pages/lift";


export default function App() {
const [activeTab, setActiveTab] = useState("index");
const [lift, setLift] = useState(null);

return (
        <div>
            {/* Main content */}
            <main style = {{margin: "0px", padding: "0px"}}>
                {activeTab === "index" && <Index enter={() => setActiveTab("home")} />}
                {activeTab === "home" && <Home selectLift={(l) => { setLift(l); setActiveTab("lift"); }} />}
                {activeTab === "lift" && <Lift lift={lift} goBack={() => setActiveTab("home")} />}
            </main>
        </div>
    );
}